<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.email"
                class="input_search"
                placeholder="搜索关键字"
                style="margin-bottom: 10px;margin-right: 10px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>

            <!-- <el-select
                v-model="search.isVip"
                clearable
                filterable
                placeholder="是否会员"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in USER_VIP_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select> -->
            <el-select
                v-model="search.vipStatus"
                clearable
                filterable
                placeholder="会员状态"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in USER_VIP_STATUS_1"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>

            <el-select
                v-model="search.hasPayExam"
                clearable
                filterable
                placeholder="是否付费测评"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in USER_HAS_PAY_EXAM"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select style="margin-bottom: 10px;margin-right: 10px" v-model="search.countryCode" clearable filterable placeholder="IP国家/地区">
              <el-option
                  v-for="item in countryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              ></el-option>
            </el-select>
            <el-select style="margin-bottom: 10px;margin-right: 10px" v-model="search.examInfoId" clearable filterable placeholder="测评题">
              <el-option
                  v-for="item in examList"
                  :key="item.examInfoId"
                  :label="item.name"
                  :value="item.examInfoId"
              ></el-option>
            </el-select>

            <div class="block timeblock"  style="display: inline-block;margin-bottom: 10px;width: 410px;margin-right: 10px">
              <el-select
                  v-model="search.timeType"
                  clearable
                  placeholder="选择时间"
                  class="xq_time_select"
              >
                <el-option
                    v-for="item in USER_TIME_TYPE_1"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                ></el-option>
              </el-select>
              <el-date-picker
                  v-model="value2"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="xq_time_picker"
              >
              </el-date-picker>
            </div>
            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
          </template>
          <el-button v-if="downShow" size="medium" type="primary" @click="upserviceList"
          >下载</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="80">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column label="用户ID" prop="userId" min-width="120"></el-table-column> -->
            <el-table-column label="用户" prop="name"  min-width="250">
              <template slot-scope="scope">
                <div style="text-align: left;">邮箱：{{ scope.row.email||'-' }}</div>
                <div style="text-align: left;">ID：{{ scope.row.userId||'-' }}</div>
                <div style="display: flex;gap: 10px; align-content: center;white-space: nowrap;">
                <div>姓名：{{ scope.row.name||'-' }}</div>
                <div>性别：{{ scope.row.sex||'-' }}</div>
                  <div>年龄：{{ scope.row.age||'-' }}</div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="性别" prop="sex" ></el-table-column>
            <el-table-column label="年龄" prop="age" ></el-table-column> -->
            <!-- <el-table-column label="邮箱" min-width="120">
              <template slot-scope="scope">
                <el-avatar 
                    v-if="scope.row.head" 
                    :src="scope.row.head" 
                    :size="40"
                  ></el-avatar>
                  <div>{{ scope.row.email }}</div>
              </template>
            </el-table-column> -->

            <el-table-column prop="countryCode" label="地区信息"></el-table-column>

            <el-table-column label="会员信息" min-width="90">
              <template slot-scope="scope">
                <div style="display: flex;gap: 10px; justify-content: center;">
                  <!-- <el-tag :type="scope.row.isVip == 1 ? 'success' : 'info'" effect="dark" size="mini">
                    {{ scope.row.isVip == 1 ? '会员' : '非会员' }}
                  </el-tag> -->
                  <el-tag :type="getVipStatusType(scope.row.vipStatus)" effect="dark" size="mini">
                    {{ scope.row.vipStatus }}
                  </el-tag>
                </div>
                
                <div class="sub-text" v-if="scope.row.vipExpireTime">
                  到期时间: {{ formatDate(scope.row.vipExpireTime) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="订阅信息" min-width="200">
              <template slot-scope="scope">
                <div style="display: flex;gap: 10px; justify-content: center;">
                  <el-tag :type="scope.row.hasSubscription == 1 ? 'success' : 'info'" effect="dark" size="mini">
                    {{ scope.row.hasSubscription == 1 ? '已测评' : '未测评' }}
                  </el-tag>
                  <el-tag v-if="scope.row.subscriptionStatus == '已到期'" type="warning" effect="dark" size="mini">已到期</el-tag>
                  <el-tag v-if="scope.row.subscriptionStatus == '已订阅'" type="success" effect="dark" size="mini">已订阅</el-tag>
                  <el-tag v-if="scope.row.subscriptionStatus == '未订阅'" type="info" effect="dark" size="mini">未订阅</el-tag>
                </div>
                <div class="sub-text" v-if="scope.row.subscriptionExpireTime">
                  到期: {{ formatDate(scope.row.subscriptionExpireTime) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="注册信息" min-width="200">
              <template slot-scope="scope">
                <div class="sub-text">注册时间: {{ formatDate(scope.row.registerTime) }}</div>
                <div>注册天数: {{ scope.row.registerDays }}天</div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  @click="getOrderDetail(scope.row)"
                  type="text"
                  size="small"
                  v-if="detailShow"
                >
                  详情
                </el-button>
                <el-button
                  @click="handleStatusChange(scope.row)"
                  type="text"
                  size="small"
                  v-if="statusShow"
                >
                  {{ scope.row.status === 1 ? '禁用' : '启用' }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="paymentChannel" label="支付方式"></el-table-column>

          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  PAY_STATUS_1,
  PAYMENT_TYPE,
  NEWUSER_ORDER,
  BIZ_TYPE,
  PAY_TYPE,
  COMMON_STATUS,
  USER_VIP_STATUS,
  USER_VIP_STATUS_1,
  USER_HAS_PAY_EXAM,
  USER_TIME_TYPE_1,
  TIME_TYPE_1,
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import { downloadFile } from "@/utils/filters/upload.js";
export default {
  data() {
    return {
      PAGE_SIZE,
      PAY_STATUS_1,
      PAYMENT_TYPE,
      NEWUSER_ORDER,
      BIZ_TYPE,
      PAY_TYPE,
      COMMON_STATUS,
      USER_VIP_STATUS,
      USER_VIP_STATUS_1,
      USER_HAS_PAY_EXAM,
      USER_TIME_TYPE_1,
      TIME_TYPE_1,
      formatDate, 
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "", //以上时间选择器

      enumCode: "PUT_WAY",
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        // value: "parentId",
        children: "examCategoryVos",
        label: "name",
      },
      channelList: [], //渠道类型list
      appList: [], //归属应用appid

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      countryList: [],
      examList: [],
      tableData: [], //顶顶那列表

      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,

      search: {},

      searchShow: false,
      downShow: false,
      detailShow: false,
      statusShow:true
    };
  },
  created() {
    this.getCountryList();
    this.getExamList();
    this.getChannelList();
    this.getAppList();
    this.getserviceList();
    this.getPermissionButtonList()

  },
  watch: {},
  methods: {
    async getCountryList() {
      const {data: res} = await this.$post(
          `/country/page`, {pageNo: 1, pageSize: 1000},
      );
      this.countryList = res.data;
    },
    async getExamList() {
      // const {data} = await this.$get(`/app/exam/list?paging=false`);
      const {data} = await this.$get(`/exam/list?status=1&pageNo=1&pageSize=1000`);
      this.examList = data.data;
    },
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'user:userManagement:query') {
            this.searchShow = true
          }
          if (item.code == 'user:userManagement:dow') {
            this.downShow = true
          }
          if (item.code == "user:userManagement:detail") {
            this.detailShow = true
          }
          if (item.code == "user:userManagement:status") {
            this.statusShow = false
          }
        })
      }
    },

    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType=='') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search[`${this.search.timeType}StartTime`] = this.value2[0];
        this.search[`${this.search.timeType}EndTime`] = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      let obj = this.search
      let startTime  = obj[`${this.search.timeType}StartTime`] ?obj[`${this.search.timeType}StartTime`] :''
      let endTime  = obj[`${this.search.timeType}EndTime`] ?obj[`${this.search.timeType}EndTime`] :''
      if(startTime && endTime){
        let _search = {
          ...this.search,
        }
        delete _search.timeType
        let queryString = ''
        for (const key in _search) {
          if (_search.hasOwnProperty(key) && _search[key]) {
            queryString += `${key}=${_search[key]}&`;
          }
        }
        // 移除字符串末尾的多余的 '&' 符号
        queryString = queryString.slice(0, -1);
        const downloadUrl = `/taotan_admin_api/user/list/export?${queryString}`
        downloadFile(downloadUrl, `userList_${new Date().getTime()}.csv`)
        this.$message.success('下载成功')
      }else {
        this.$message.warning('请选择时间')
      }
    },
    //获取归属应用
    async getAppList() {
      const { data: orgData } = await this.$get(`/app/list?paging=false`);
      this.appList = orgData.data;
    },
    //获取渠道 账号 类型==改
    async getChannelList() {
      const { data: orgData } = await this.$get(`/channel/account/list?paging=false`);
      this.channelList = orgData.data;
    },
    // 获取渠道 商户
    // async getshopList() {
    //   const { data: orgData } = await this.$get(`/channel/mch/list`);
    //   this.shopList = orgData.data;
    // },
    SearchServiceList(){
      this.page.pageNo = 1
      this.getserviceList()
    },
    //订单列表
    async getserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == "") {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search[`${this.search.timeType}StartTime`] = this.value2[0];
        this.search[`${this.search.timeType}EndTime`] = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }

      this.loading = true;
      const { data: res } = await this.$get(
        `/user/list/query`,
        { params: { ...this.search, ...this.page } },
        {
          headers: {
            isLoading: true,
          },
        }
      );
      this.loading = false;
      this.tableData = res.data.records;
      this.page.count = res.data.total;
    },
    //switch状态改变 --接口 修改岗位状态
    handleSwitch(index) {
      //interface
      this.$put(`/user/info/status/${this.tableData[index].userId}`).then(res=>{
        if(res.data.result==200){
          this.$message.success('操作成功')
        }
      });
    },
    //订单详情
    async getOrderDetail(row) {
      this.$router.push({
        name: "USER_DETAIL_PAGE",
        query: {
          id: 3,
          title: "用户列表",
          key: "userId",
          value: JSON.stringify(row.email),
          path: "/user/list/detail",
        },
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
    getVipStatusType(status) {
      if (status === '已开通') {
        return 'success';
      } else if (status === '已过期') {
        return 'warning';
      } else if (status === '未开通') {
        return 'info';
      }
      return '';
    },
    getAccountTypeText(type) {
      // Implement the logic to return the text based on the account type
      // This is a placeholder and should be replaced with the actual implementation
      return "Unknown";
    },
    handleStatusChange(row) {
      // Implement the logic to handle status change
      // This is a placeholder and should be replaced with the actual implementation
      console.log("Status change not implemented");
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>